import { render, staticRenderFns } from "./ValoresDispensacion.vue?vue&type=template&id=c9ac0bd2&scoped=true"
import script from "./ValoresDispensacion.vue?vue&type=script&lang=js"
export * from "./ValoresDispensacion.vue?vue&type=script&lang=js"
import style0 from "./ValoresDispensacion.vue?vue&type=style&index=0&id=c9ac0bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ac0bd2",
  null
  
)

export default component.exports